import styled from 'styled-components';
import { LoadingState } from './types.js';

var LoadingRoot = styled.div.withConfig({
  displayName: "styles__LoadingRoot",
  componentId: "sc-k7h4tk-0"
})(["", " & path{stroke:", ";}"], function (props) {
  return props.state === LoadingState.Loading && 'transform: scaleY(-1);';
}, function (props) {
  return props.color;
});

export { LoadingRoot };
